import { signal } from '@angular/core';
import { SurfaceSvgComponent } from './surface-svg/surface-legend-svg';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';

export const SURFACE_LEGEND: TwcLegendParams = {
  title: 'SURFACE FORECAST',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: SurfaceSvgComponent },
  legendComponent: TwcLegendComponent
};
